import { DownloadOutlined } from "@ant-design/icons";
import { Input, Steps, message } from "antd";
import React, { useState, useEffect } from "react";
import ExcelRenderer from "papaparse";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  downloadBulkEmployees,
  getUserFields,
  UploadBulk,
  uploadBulkEmployees,
} from "../../../../actions/employees/employees";
import PageHeader from "../../../PageHeader";
import MapFields from "./MapFields";
import Close from "../../../../assets/icons/close.png";
import { hasAccess } from "../../../../utils";
import useDownloadCSV from "../../../../config/useDownloadCSV";

const Step = Steps.Step;

const { TextArea } = Input;

export const chunk = function (arr, chunkSize) {
  var R = [];
  for (var i = 0; i < arr.length; i += chunkSize)
    R.push(arr.slice(i, i + chunkSize));
  return R;
};

const AddBulkUsers = () => {
  const dispatch = useDispatch();
  const downloadCSV = useDownloadCSV();
  const [file, setFile] = React.useState(null);
  const [fileData, setFileData] = React.useState(null);
  const [step, setStep] = React.useState(0);
  const [columnRows, setColumnRows] = useState({});

  const [columnHeader, setColumnHeader] = useState([]);
  const history = useHistory()
  const downloadLink = useSelector(
    (state) =>
      state?.users?.downloadLink?.data?.response?.template_fields_link
  );
  const userFields = useSelector(
    (state) => state?.users?.user_fields?.data?.response?.user_template_fields
  );

  const uploadRes = useSelector((state) => state?.users?.upload);

  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState("");
  const [errorRows, setErrorRows] = useState({});
  const [mapFields, setMapFields] = useState(false);

  console.log(TextArea, tableData, errorRows, mapFields);

  const [fileContent, setFileContent] = useState({
    name: "",
    columns: [],
    rows: [],
  });
  // eslint-disable-next-line
  function getTableData() {
    var keys = Object.values(columnRows);
    var mapKeys = Object.keys(columnRows);
    let result = [];

    fileContent.rows.forEach((value, row) => {
      var obj = {};
      let gstRegex = new RegExp(
        /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/
      );
      mapKeys.forEach((key, i) => {
        obj[key] = value[keys[i]];

        if (!gstRegex.test(value[keys[i]]) && keys[i] === 1) {
          setErrorRows((rows) => ({
            ...rows,
            [row]: rows[row]
              ? rows[row].push({ message: "Invalid Value", column: keys[i] })
              : [{ message: "Invalid Value", column: keys[i] }],
          }));
        }
      });
      result.push(obj);
    });
    setTableData(result);

    columnHeader.forEach((column, i) => {
      column.accessor = mapKeys[i];
    });

    setFileContent({
      name: "",
      columns: [],
      rows: [],
    });
  }

  const mapToFields = () => {
    let values = Object.values(columnRows);
    if (values.length > 0 && fileContent.name !== "") {
      setMapFields(true);
    }
  };

  const mapToTable = () => {
    let formData = new FormData();
    formData.append("format", "csv");
    formData.append("input_file", file);
    userFields.forEach((ele) => {
      formData.append(
        `file_header_fields[${ele}]`,
        fileContent.columns.find((itm) => itm === ele)
      );
    });

    dispatch(uploadBulkEmployees(formData));
  };

  useEffect(() => {
    dispatch(getUserFields());
    dispatch(downloadBulkEmployees());
    return () => {
      dispatch({
        type: UploadBulk.RESET,
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (userFields?.length > 0) {
      let arr = [];
      userFields.forEach((ele) =>
        arr.push({
          Header: ele,
          accessor: "",
        })
      );
      setColumnHeader(arr);
    }
  }, [userFields]);

  useEffect(() => {
    if (file) {
      readFile(file);
    }
    // eslint-disable-next-line
  }, [file]);

  useEffect(() => {
    if (uploadRes?.success) {
      setFile(null);
      setFileData(uploadRes?.data?.response?.response);
      setStep(0);
      setFileContent({
        name: "",
        columns: [],
        rows: [],
      });
      setColumnRows({})
    }
  }, [uploadRes]);

  const readFile = (file) => {
    setError("");
    let cols = [];
    let rows = [];
    var keys = Object.keys(columnRows);

    let fileObj = file;

    if (
      fileObj &&
      (fileObj.type === "application/vnd.ms-excel" ||
        fileObj.type === "text/csv") &&
      fileObj.size < parseInt("5242880")
    ) {
      setFileContent({ ...fileContent, name: file.name });

      //just pass the fileObj as parameter
      ExcelRenderer.parse(file, {
        complete: (resp) => {
          if (resp && resp.data) {
            cols = resp.data[0];
            rows = resp.data.slice(1);
            setFileContent({
              ...fileContent,
              name: file.name,
              columns: cols,
              rows: rows?.filter((ele) => ele.length > 0),
            });
          }
          let obj = {};
          keys.forEach((key, i) => {
            obj[key] = i;
          });
          setColumnRows(obj);
        },
      });
    }
  };

  return (
    <div>
      <div className="heading-div">
        <PageHeader
          title={`Upload Users`}
          navigation={{
            Home: hasAccess("dashboard", "read") || hasAccess("dashboard", "write") ? "/dashboard" : "",
            Users: "/setting/users/",
          }}
          isClose={true}
          onCloseClick={() => {
            history.push("/setting/users/")
          }}
        />

        {fileData && (
          <div
            className="success-toast mb2"
            onClick={() => {
              setFileData(null);
              dispatch({
                type: UploadBulk.RESET,
              });
            }}
          >
            {fileData}
          </div>
        )}
        <div className="card bulk-users">
          <div className="steps-align">
            <Steps current={step} className="steps">
              <Step
                title={"Select File"}
                onClick={() => {
                  setStep(0);
                }}
              />

              <Step
                title={"Map Files"}
                onClick={() => {
                  setStep(1);
                }}
              />
            </Steps>
          </div>
          {step === 0 ? (
            <>
              <div className="flex-center w100">
                <div className="showcase-box" onClick={() => {
                  // Fetch the CSV file from the URL
                  downloadCSV(downloadLink, "sample_user.csv")
                }}>
                  <div className="mt1" style={{ color: "var(--primary-blue)" }}>
                    <DownloadOutlined width="2rem" />
                    <br />
                    Download Sample File
                    <p style={{ color: "var(--text-primary)" }}>
                      You can download the sample template file (.csv) and fill in the information.
                    </p>
                  </div>
                </div>
                <input
                  type={"file"}
                  id="file"
                  onChange={(e) => {
                    setFileData(null);
                    if (e.target.files[0]?.type === "text/csv")
                      setFile(e.target.files[0]);
                    else
                      message.error(<span className="messageText">Only CSV files are allowed</span>)
                  }}
                  className="d-none"
                />
                <div
                  className="showcase-box ml1"
                  onClick={() => {
                    document.getElementById("file").click();
                    document.getElementById("file").value = null;
                  }}
                >
                  {file && file.name ? (
                    <div className="mt1">
                      <span
                        className="cursor"
                        onClick={(e) => {
                          e.stopPropagation();
                          setFile(null);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <img src={Close} width={20} alt={"close"} />
                      </span>
                      <DownloadOutlined width="2rem" />
                      <br />
                      <p className="ellipsis">{file.name}</p>
                    </div>
                  ) : (
                    <div className="mt1">
                      <DownloadOutlined width="2rem" />
                      <br />
                      Upload your file
                      <p>
                        You can edit information in the file (.csv) and upload
                        the same.
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex-center p2">
                <button
                  className="primary-btn"
                  disabled={!file}
                  onClick={() => {
                    // let formData = new FormData();
                    // formData.append("input_file", file);
                    // formData.append("format", "csv");
                    setStep(1);
                    // dispatch(uploadBulk(formData));
                  }}
                // disabled={uploadData?.loading}
                >
                  Proceed
                </button>
              </div>

              <div className="instructions">
                <h3>Instructions</h3>
                <ul>
                  <li>User Grade, Designation, Roles, Title fields, Annual Income, Source Income Type and Gender entered should match exactly with the master data available in the application.</li>
                  <li>Employee ID should be unique; the system will not allow duplicate user IDs.</li>
                  <li>The format for entering the Date of Birth (DOB) should be <strong>DD-MM-YYYY</strong> (e.g., 25-08-1996).</li>
                  <li>Email should be of valid format, and the system will not allow duplicate email IDs for an organization.</li>
                  {/* <li>The Annual Income value should be a numeric entry, within the range of 0 to 999,999,999.</li> */}
                  <li>Primary Phone should be a valid mobile number of 10 digits.</li>
                  <li>Email ID of the approvers should be provided for assigning them to the user (e.g., Reporting Manager - rm@yopmail.com).</li>
                  <li>On successful file upload, the creation of users functionality will run in an asynchronous job. After the successful completion of the job, an email will be triggered to the administrator with the status of user creation.</li>
                  <li>The upload file should be in <strong>CSV format</strong>.</li>
                </ul>

              </div>
            </>
          ) : (
            <div>
              <MapFields
                setColumnRows={setColumnRows}
                error={error}
                fileContent={fileContent}
                mapToTable={mapToTable}
                columnRows={columnRows}
                columnHeader={columnHeader}
                setError={setError}
                setMapFields={setMapFields}
                mapToFields={mapToFields}
                setStep={setStep}
                uploadLoading={uploadRes?.loading}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddBulkUsers;
